/*
 * Delays app / tracking scripts until the visitor first interacts with the page.
 * Pairs with the MutationObserver in snippets/meta-tags.liquid, which rewrites
 * those scripts (data-src / type="text/lazyload") as they are added to the page.
 * Previously loaded from another store's CDN (cdn.shopify.com/s/files/1/0644/2975/2553/...);
 * now hosted in the theme so it is under our control and can be deferred.
 */
var script_loaded = false;

function loadJSscripts() {
    if (script_loaded) return;
    observer.disconnect();
    script_loaded = true;

    document.querySelectorAll('iframe.lazy').forEach(function (frame) {
        var datasrc = frame.dataset.src;
        if (datasrc != null) frame.src = datasrc;
    });

    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i++) {
        if (scripts[i].getAttribute('data-src') !== null) {
            scripts[i].setAttribute('src', scripts[i].getAttribute('data-src'));
            delete scripts[i].dataset.src;
        }
        if (scripts[i].getAttribute('type') == 'text/lazyload') {
            var replacement = document.createElement('script');
            for (var a = 0; a < scripts[i].attributes.length; a++) {
                var attr = scripts[i].attributes[a];
                replacement.setAttribute(attr.name, attr.value);
            }
            replacement.type = 'text/javascript';
            replacement.innerHTML = scripts[i].innerHTML;
            var parent = scripts[i].parentNode;
            var old = scripts[i];
            parent.insertBefore(replacement, old);
            parent.removeChild(old);
        }
    }

    var links = document.getElementsByTagName('link');
    for (var j = 0; j < links.length; j++) {
        if (links[j].getAttribute('data-href') !== null) {
            links[j].setAttribute('href', links[j].getAttribute('data-href'));
            delete links[j].dataset.href;
        }
    }

    document.dispatchEvent(new CustomEvent('asyncLazyLoad'));
}

['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click', 'keypress', 'touchmove'].forEach(function (evt) {
    window.addEventListener(evt, loadJSscripts, { passive: true });
});
